import PARENT from '../types';

const BOOTSTRAP_CIS = `${PARENT}/BOOTSTRAP_CIS`;

export const RESET_BOOTSTRAP_CIS = `${BOOTSTRAP_CIS}/RESET`;

export default BOOTSTRAP_CIS;
